import React from "react";
import { BiCheckCircle } from "react-icons/bi";
import { Button } from "../Button";
import { ButtonDecline } from "../ButtonDecline";
import { Content } from "./styles";

interface Props {
  id: number;
  value: number;
  title: string;
  icon: string;
  price: string;
  attributes: string[];
  onSelect: (value: number, id: number) => void;
  isSelected?: boolean;
}
export function Plan({
  id,
  title,
  icon,
  price,
  attributes,
  value,
  onSelect,
  isSelected = false,
  ...rest
}: Props) {
  function handleSelectPlan() {
    onSelect(value, id)
  }
  return (
    <Content  isSelected={isSelected}>
      <img alt="icon" src={icon} />
      <h3>{title}</h3>
      <h1>{price}</h1>
      <div className="horinzontal-line"></div>
      <div className="attributes">
        {attributes.map((attribute, index) => (
          <div className="attribute" key={index}>
            <BiCheckCircle />
            <span>{attribute}</span>
          </div>
        ))}
      </div>
      <div className="btn">
        {isSelected ? (
          <ButtonDecline title="Selecionado"/>
        ) : (
          <Button title="Selecionar Plano" onClick={handleSelectPlan} />
        )}
      </div>
    </Content>
  );
}
